const contractedMgmt = {
  TabName: "Contracted Risk Management",
  link: "/riskmanagement/contracted-mgmt",
  value: "contracted-mgmt"
};
const unallocatedMgmt = {
  TabName: "Unallocated Tickets",
  link: "/riskmanagement/unallocated-mgmt",
  value: "unallocated-mgmt"
};
const internalMgmt = {
  TabName: "Inventory Management",
  link: "/riskmanagement/inventory-mgmt",
  value: "inventory-mgmt"
};

const usersTab = { TabName: "Users", link: "/settings/users", value: "users" };
const billingTab = {
  TabName: "Billing",
  link: "/settings/billing",
  value: "billing"
};
const mandatoryTab = {
  TabName: "Mandatory Cells",
  link: "/settings/mandatory-fields",
  value: "mandatory-fields"
};
const dashboardCell = {
  TabName: "Farm Overview",
  link: "/app/dashboard",
  value: "dashboard"
};
const counterPartydashboardCell = {
  TabName: "Counter Party Overview",
  link: "/app/dashboard",
  value: "dashboard"
};
const TabsConstants = {
  FormSetupScreen: [
    {
      TabName: "Farm information",
      link: "/farmsetup/farminformation",
      value: "farminformation"
    },
    {
      TabName: "Trucklines",
      link: "/farmsetup/trucklines",
      value: "trucklines"
    },
    {
      TabName: "Destinations",
      link: "/farmsetup/destinations",
      value: "destinations"
    },
    {
      TabName: "Counterparties",
      link: "/farmsetup/counterparties",
      value: "counterparties"
    }
  ],
  FarmInformationChildren: [
    {
      TabName: "Field Groups",
      link: "/farmsetup/farminformation/field-groups",
      value: "field-groups"
    },
    {
      TabName: "Commodities",
      link: "/farmsetup/farminformation/commodities",
      value: "commodities"
    },
    {
      TabName: "Commodity Varieties",
      link: "/farmsetup/farminformation/commodity-varieties",
      value: "commodity-varieties"
    },
    {
      TabName: "On-site Storage",
      link: "/farmsetup/farminformation/onsite-storage",
      value: "onsite-storage"
    }
  ],
  FieldGroupInfo: [
    // {
    //   TabName: "Edit Group",
    //   link: "/farmsetup/farminformation/field-groups/edit",
    //   value: "editGroup"
    // },
    {
      TabName: "Fields",
      link: "/farmsetup/farminformation/field-groups/fields",
      value: "fields"
    },
    {
      TabName: "Load Number Indicators",
      link: "/farmsetup/farminformation/field-groups/indicators",
      value: "indicators"
    }
  ],
  HomeScreen: {
    SUPER_ADMIN: [
      dashboardCell,
      { TabName: "Tickets", link: "/app/tickets", value: "tickets" },
      { TabName: "Contracts", link: "/app/contracts", value: "contracts" }
    ],
    ACCOUNT_OWNER: [
      dashboardCell,
      { TabName: "Tickets", link: "/app/tickets", value: "tickets" },
      { TabName: "Contracts", link: "/app/contracts", value: "contracts" }
    ],
    ACCOUNT_ADMIN: [
      dashboardCell,
      { TabName: "Tickets", link: "/app/tickets", value: "tickets" },
      { TabName: "Contracts", link: "/app/contracts", value: "contracts" }
    ],
    FARM_EMPLOYEE: [
      dashboardCell,
      { TabName: "Tickets", link: "/app/tickets", value: "tickets" }
    ],
    COUNTER_PARTY: [
      counterPartydashboardCell,
      { TabName: "Tickets", link: "/app/counterPartytickets", value: "tickets" }
    ]
  },
  RiskManagementScreen: {
    SUPER_ADMIN: [contractedMgmt, unallocatedMgmt, internalMgmt],
    ACCOUNT_OWNER: [contractedMgmt, unallocatedMgmt, internalMgmt],
    ACCOUNT_ADMIN: [contractedMgmt, unallocatedMgmt, internalMgmt],
    FARM_EMPLOYEE: []
  },
  SettingScreen: {
    SUPER_ADMIN: [usersTab, mandatoryTab],
    ACCOUNT_OWNER: [usersTab, billingTab, mandatoryTab],
    ACCOUNT_ADMIN: [usersTab, billingTab, mandatoryTab],
    FARM_EMPLOYEE: [usersTab, billingTab, mandatoryTab]
  },
  DestinationScreen: [
    {
      TabName: "Internal",
      link: "/farmsetup/destinations/internal",
      value: "internal"
    },
    {
      TabName: "External",
      link: "/farmsetup/destinations/external",
      value: "external"
    }
  ],
  MandatoryFieldsScreen: [
    {
      TabName: "Ticket",
      link: "/settings/mandatory-fields/ticket",
      value: "ticket"
    },
    {
      TabName: "Contract",
      link: "/settings/mandatory-fields/contract",
      value: "contract"
    }
  ],
  destinationTypeId: [
    { name: "External", id: "2" },
    { name: "Internal", id: "1" }
  ],
  partyType: [
    { name: "Direct", id: 1 },
    { name: "Broker", id: 2 }
  ],
  OriginTypeSelection: [
    { name: "Field", id: "1" },
    { name: "On-site Storage", id: "2" }
  ]
};

export default TabsConstants;



// WEBPACK FOOTER //
// ./src/constants/TabsConstants.js